export default __webpack_public_path__ + "static/media/favicon.517d60d3.ico";